import React from 'react'
import { Auth } from 'aws-amplify';

class Signout extends React.Component {
  constructor(props) {
    super();
    this.handleLogout();
  }

  handleLogout() {
    Auth.signOut().then(data => {
        const { history } = this.props;
        sessionStorage.clear();
        localStorage.clear();
        history.push('/user/signin');
    }).catch(error => {
        const { history } = this.props;
        history.push('/');
    });
  }

  render() {
		return (<div></div>);
  }
}

export default Signout;
